import {TransportMethod, transportMethod} from "@ots-frontend/ots-data";
import {Group} from "@mantine/core";
import {IconChartDots3, IconTruck} from "@tabler/icons-react";
import {ReactNode, useMemo} from "react";
import {FormattedDatabaseCode} from "../../../text/FormattedDatabaseCode/FormattedDatabaseCode";

export const HaulMethodCell = (props: { haulMethod?: TransportMethod }) => {
  const {haulMethod: method} = props

  const icon: ReactNode | undefined = useMemo(() => {
    if (method === transportMethod.trucking) {
      return <IconTruck size={14} />
    } else if (method === transportMethod.pipeline) {
      return <IconChartDots3 size={14}/>
    } else {
      return undefined
    }
  }, [method])

  if (!method) {
    return null
  }

  return (
    <Group spacing="xs">
      {icon && icon}
      <FormattedDatabaseCode value={method}/>
    </Group>
  )
}
